<div class="pane">
	<div class="title-bar">
		<div *ngIf="showCloseButton" class="button icon-only close-pane" (click)="close()"><i class="fa fa-times"></i></div>
		<h2 class="title"><i *ngIf="icon" class="fa fa-{{icon}}"></i> {{title}}</h2>
	</div>
	<div class="pane-contents">
		<ng-content></ng-content>
	</div>
</div>
